module.exports = __webpack_public_path__ + "static/media/sale1.7516901d.jpeg";